/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface EvidencePaymentWithEvidenceErrors
 */
export interface EvidencePaymentWithEvidenceErrors {
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidenceErrors
     */
    'detectedDpi'?: EvidencePaymentWithEvidenceErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidenceErrors
     */
    'calculatedDpi'?: EvidencePaymentWithEvidenceErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidenceErrors
     */
    'colorGradation'?: EvidencePaymentWithEvidenceErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidenceErrors
     */
    'heightMillis'?: EvidencePaymentWithEvidenceErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidenceErrors
     */
    'widthMillis'?: EvidencePaymentWithEvidenceErrorsWidthMillisEnum;
}

export const EvidencePaymentWithEvidenceErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidencePaymentWithEvidenceErrorsDetectedDpiEnum = typeof EvidencePaymentWithEvidenceErrorsDetectedDpiEnum[keyof typeof EvidencePaymentWithEvidenceErrorsDetectedDpiEnum];
export const EvidencePaymentWithEvidenceErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidencePaymentWithEvidenceErrorsCalculatedDpiEnum = typeof EvidencePaymentWithEvidenceErrorsCalculatedDpiEnum[keyof typeof EvidencePaymentWithEvidenceErrorsCalculatedDpiEnum];
export const EvidencePaymentWithEvidenceErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type EvidencePaymentWithEvidenceErrorsColorGradationEnum = typeof EvidencePaymentWithEvidenceErrorsColorGradationEnum[keyof typeof EvidencePaymentWithEvidenceErrorsColorGradationEnum];
export const EvidencePaymentWithEvidenceErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidencePaymentWithEvidenceErrorsHeightMillisEnum = typeof EvidencePaymentWithEvidenceErrorsHeightMillisEnum[keyof typeof EvidencePaymentWithEvidenceErrorsHeightMillisEnum];
export const EvidencePaymentWithEvidenceErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidencePaymentWithEvidenceErrorsWidthMillisEnum = typeof EvidencePaymentWithEvidenceErrorsWidthMillisEnum[keyof typeof EvidencePaymentWithEvidenceErrorsWidthMillisEnum];


